import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

export const useCourseData = (id, authState) => {
    const [orders, setOrders] = useState([]);
    const [services, setServices] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [employeeoption, setEmployeeOption] = useState([]);
    const [employeeoptionWithFilter, setEmployeeOptionWithFilter] = useState([]);
    const [bills, setBills] = useState([]);
    const [options, setOptions] = useState([]);
    const [Modifiedorder, setModifiedOrder] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const list_of_orders = await axios.get(process.env.REACT_APP_API_URL + `/course/patientorder/byId/${id}`, { headers: { accessToken: Cookies.get('accessToken'), } })
            const filter_list_of_oders = list_of_orders.data.filter((item) => item.item_status !== 3)
            setOrders(filter_list_of_oders);

            const servicesRes = await axios.get(process.env.REACT_APP_API_URL + `/course/service`, { headers: { accessToken: Cookies.get('accessToken'), } })
            const filterService = servicesRes.data.filter(item => item.department_id === authState.department_id)
            setServices(filterService);

            const employeeresponse = await axios.get(process.env.REACT_APP_API_URL + `/employee`, { headers: { accessToken: Cookies.get('accessToken'), } });
            setEmployee(employeeresponse.data);
            const newemployee = [
                ...employeeresponse.data.map(item => ({ value: item.id, label: `${item.name} [${item.nickname}]` })),
                { value: -1, label: 'พาร์ทไทม์' },
                { value: 0, label: 'ไม่มี' }

            ];

            const filterNewemployee = [
                ...employeeresponse.data
                    .filter(item => item.department_id === authState.department_id)
                    .map(item => ({ value: item.id, label: `${item.name} [${item.nickname}]` })),
                { value: -1, label: 'พาร์ทไทม์' },
                { value: 0, label: 'ไม่มี' }
            ];
            setEmployeeOption(newemployee)
            setEmployeeOptionWithFilter(filterNewemployee)

            const billitemresponse = await axios.get(process.env.REACT_APP_API_URL + `/course/billitem/byId/${id}`, { headers: { accessToken: Cookies.get('accessToken'), } })
            setBills(billitemresponse.data)

            const checkProductResponse = await axios.get(process.env.REACT_APP_API_URL + `/course/all-products-stock-status/${authState.department_id}`, { headers: { accessToken: Cookies.get('accessToken'), } })


            const stockStatusMap = checkProductResponse.data.reduce((map, product) => {
                map[product.service_id] = { status: product.status, quantity: product.quantity, };
                return map;
            }, {});
            const combinedOptions = filterService.reduce(
                (acc, item) => {
                    const productData = item.service_type === 3 ? stockStatusMap[item.service_id] : null;
                    const isAvailable = productData ? productData.status : false;
                    const quantity = productData ? productData.quantity : 0;

                    if (item.service_type === 1 && item.status !== 'inactive') {
                        acc[0].options.push({ value: item.service_id, label: item.service_name, price: item.service_price, type: item.service_type, disabled: false, });
                    } else if (item.service_type === 2 && item.status !== 'inactive') {
                        acc[1].options.push({ value: item.service_id, label: item.service_name, price: item.service_price, type: item.service_type, disabled: false, });
                    } else if (item.service_type === 3 && item.status !== 'inactive') {
                        acc[2].options.push({ value: item.service_id, label: `${item.service_name} (จำนวนคงเหลือ: ${quantity})`, price: item.service_price, type: item.service_type, disabled: !isAvailable, });
                    }
                    return acc;
                },
                [
                    { label: 'Services', options: [] },
                    { label: 'Courses', options: [] },
                    { label: 'Product', options: [] },
                ]
            );

            setOptions(combinedOptions);

            const newData = filter_list_of_oders.map(ordersItem => {
                let matchingItem = null;
                matchingItem = filterService.find(item => item.service_id === ordersItem.item_id);
                return {
                    key: ordersItem.id,
                    id: ordersItem.id,
                    item_id: ordersItem.item_id, // Add service_id
                    item_name: matchingItem?.service_name,
                    item_times: ordersItem.item_times,
                    item_totalprice: ordersItem.item_totalprice,
                    type: ordersItem.type,
                    item_paid: ordersItem.item_paid,
                    item_status: ordersItem.item_status,
                    orders_price: ordersItem.item_times * matchingItem?.service_price,
                    relize_revenue: ((ordersItem.item_times - ordersItem.item_remain) * (ordersItem.item_totalprice / ordersItem.item_times)).toFixed(2),
                    item_remain: ordersItem.item_remain,
                    inviter_id: ordersItem.inviter_id,
                    discount_value: ordersItem.discount_value,
                    discount_id: ordersItem.discount_id,
                    comission_type: ordersItem.comission_type
                };
            });

            setModifiedOrder(newData)
            setLoading(false)
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }, [id, authState.department_id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return {
        orders,
        services,
        employee,
        employeeoption,
        employeeoptionWithFilter,
        bills,
        options,
        Modifiedorder,
        loading,
        setLoading,
        fetchData,
        setModifiedOrder,
        setOrders,
        setBills,
        setOptions
    };
};
